import { useState } from 'react';
import { useQuery } from '@apollo/client';

import { GET_ROLE } from '@atom/graph/role';
import { useNavigation } from '@atom/hooks/useNavigation';
import { Progress } from '@atom/mui';
import { PoliciesConnectionInput } from '@atom/types/policy';
import {
  RoleAssigneesConnectionInput,
  RoleDetail as RoleDetailType,
} from '@atom/types/role';

import RoleHeader from './header/RoleHeader';
import RoleAssignees from './roleAssignees/RoleAssignees';
import RolePolicies from './rolePolicies/RolePolicies';
import RoleContext from './RoleContext';

import classes from './roleDetail.module.css';

enum View {
  POLICIES,
  ASSIGNEES,
}

const RoleDetail = () => {
  const [view, setView] = useState<View>(View.POLICIES);
  const [, { params }] = useNavigation();
  const { id } = params;

  const [assigneesInput, setAssigneesInput] =
    useState<RoleAssigneesConnectionInput>({
      page: 1,
      limit: 15,
      sortBy: 'name',
      sortDirection: 'asc',
    });

  const [policiesInput, setPoliciesInput] = useState<PoliciesConnectionInput>({
    page: 1,
    limit: 15,
    sortBy: 'createdDate',
    sortDirection: 'asc',
  });

  const { data, error, loading, refetch } = useQuery<
    { role: RoleDetailType },
    {
      id: string;
      assigneesInput: RoleAssigneesConnectionInput;
      policiesInput: PoliciesConnectionInput;
    }
  >(GET_ROLE, {
    variables: {
      id,
      assigneesInput,
      policiesInput,
    },
    fetchPolicy: 'network-only',
  });

  if (error || !data) {
    return (
      <div className={classes.spinnerContainer}>
        <Progress />
      </div>
    );
  }

  const getActiveView = () => {
    const views = {
      [View.POLICIES]: <RolePolicies />,
      [View.ASSIGNEES]: <RoleAssignees />,
    };

    return views[view];
  };

  const { role } = data;

  return (
    <RoleContext.Provider
      value={{
        role,
        refetch,
        loading,
        assigneesInput,
        setAssigneesInput,
        policiesInput,
        setPoliciesInput,
        view,
        setView,
      }}
    >
      <div className={classes.container}>
        <RoleHeader />
        <div className={classes.contentContainer}>
          <div className={classes.centerPaneContainer}>
            <div className={classes.centerPane}>{getActiveView()}</div>
          </div>
        </div>
      </div>
    </RoleContext.Provider>
  );
};

export default RoleDetail;
